import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { WikiComponent } from './wiki.component';
// import { CKEditorModule } from '@ckeditor/';
import { FormsModule } from '@angular/forms';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { RouterModule } from '@angular/router';
import { EditorComponent } from './editor/editor.component';
import { EditorContainerComponent } from './editor-container/editor-container.component';
import { ReorderContainerComponent } from './reorder-container/reorder-container.component';
import { SearchResultComponent } from './search-result/search-result.component';
import { SideNavTreeComponent } from './side-nav-tree/side-nav-tree.component';


@NgModule({
  declarations: [
    WikiComponent,
    EditorComponent,
    EditorContainerComponent,
    ReorderContainerComponent,
    SearchResultComponent,
    SideNavTreeComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    CKEditorModule,
    DragDropModule,
    RouterModule
  ],
  exports: [
    WikiComponent
  ]
})
export class WikiModule { }
